export const MENSAJE_ALERTA_TYPE = {
    Exito : "exito",
    Error : "error",
    Warning : "warning",
}